import StudyList from "../components/StudyList";

function StudyListPage() {
  return <StudyList />;
}

export default StudyListPage;
